import { cloneDeep, findIndex, remove } from "lodash";
import {
  CREATE_CERTIFICATES_SUCCESS,
  DELETE_CERTIFICATE_SUCCESS,
  GET_ALL_STUDENT_CERTIFICATE_SAVED_SUCESS,
  GET_CERTIFICATE_DETAILS_SUCCESS,
  GET_CERTIFICATE_LIST_SUCCESS,
  GET_DUPLICATE_CERTIFICATE_SUCCESS,
  GET_STUDENT_CERTIFICATE_SAVED_SUCESS,
  UPDATE_CERTIFICATE_SUCCESS,
} from "../constants";

export const initialState = {
  certificatesDetail: undefined,
  currentCertificateView: undefined,
  certificateStudentDetails: undefined,
  userCertificate: undefined,
};
export const CertificateReducer = (state = initialState, action) => {
  //switch between action.type
  switch (action.type) {
    case GET_ALL_STUDENT_CERTIFICATE_SAVED_SUCESS: {
      return {
        ...state,
        userCertificate: action.payload,
      };
    }
    case GET_STUDENT_CERTIFICATE_SAVED_SUCESS: {
      return {
        ...state,
        certificateStudentDetails: action.payload,
      };
    }
    case CREATE_CERTIFICATES_SUCCESS:
      const tempCertificate = cloneDeep(state.certificatesDetail);
      if (tempCertificate.data) {
        tempCertificate.data.splice(0, 0, action.payload);
      }
      return {
        ...state,
        certificatesDetail: tempCertificate,
      };
    case GET_CERTIFICATE_LIST_SUCCESS:
      return {
        ...state,
        certificatesDetail: action.payload,
      };
    case DELETE_CERTIFICATE_SUCCESS: {
      const tempCertificate = cloneDeep(state.certificatesDetail);
      remove(tempCertificate.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        certificatesDetail: tempCertificate,
      };
    }
    case GET_DUPLICATE_CERTIFICATE_SUCCESS: {
      const tempCertificate = cloneDeep(state.certificatesDetail);
      if (tempCertificate.data) {
        tempCertificate.data.push(action.payload);
      }
      return {
        ...state,
        certificatesDetail: tempCertificate,
      };
    }

    case GET_CERTIFICATE_DETAILS_SUCCESS: {
      return {
        ...state,
        currentCertificateView: action.payload,
      };
    }
    case UPDATE_CERTIFICATE_SUCCESS: {
      const tempCertificateDetails = cloneDeep(state.certificatesDetail);
      const index = findIndex(
        tempCertificateDetails.data,
        (obj) => obj._id === action.payload._id
      );

      if (index !== -1) {
        tempCertificateDetails.data[index] = action.payload;
      }
      return {
        ...state,
        certificatesDetail: tempCertificateDetails,
      };
    }

    default:
      return state;
  }
};
